import { render, staticRenderFns } from "./Szervezetek.vue?vue&type=template&id=5bcaa66b&"
import script from "./Szervezetek.vue?vue&type=script&lang=js&"
export * from "./Szervezetek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports